{
  "NAVIGATION": [
    { "link": "/insights", "label": "Insights", "navKey": "INSIGHTS", "featureOff": "monthly_stats" },
    { "link": "/team-dashboard", "label": "Team Dashboard", "navKey": "TEAM_DASHBOARD", "featureOff": "monthly_stats" },
    { "link": "/team-dashboard", "label": "Insights", "navKey": "TEAM_DASHBOARD", "featureOn": "monthly_stats" },
    { "link": "/pipeline", "label": "Pipeline", "navKey": "PIPELINE" },
    { "link": "/my-queue", "label": "My Queue", "navKey": "MY_QUEUE" },
    { "link": "/inprogress", "label": "Open Tasks", "navKey": "IN_PROGRESS" },
    { "link": "/search-flights", "label": "Search Flights", "navKey": "SEARCH_FLIGHTS" },
    { "link": "/clients", "label": "Clients", "navKey": "CLIENTS" },
    { "link": "/leads", "label": "Leads", "navKey": "LEADS" },
    { "link": "/flight-requests", "label": "Flight Requests", "navKey": "FLIGHT_REQUESTS" },
    { "link": "/orders", "label": "Orders", "navKey": "ORDERS" },
    { "link": "/upcoming-flights", "label": "Upcoming Flights", "navKey": "UPCOMING_FLIGHTS" },
    { "link": "/support-requests", "label": "Support Requests", "navKey": "SUPPORT_REQUESTS" },
    { "link": "/invoices", "label": "Invoices", "navKey": "INVOICES" },
    { "link": "/bookings", "label": "Bookings", "navKey": "BOOKINGS" },
    { "link": "/payments", "label": "Payments", "navKey": "PAYMENTS" },
    { "link": "/costs", "label": "Costs", "navKey": "COSTS" },
    { "link": "/financial-events", "label": "Financial Events", "navKey": "FINANCIAL_EVENTS" },
    { "link": "/miles-inventory", "label": "Miles Inventory", "navKey": "MILES_INVENTORY" },
    { "link": "/miles-programs", "label": "Miles Programs", "navKey": "MILES_PROGRAMS" },
    { "link": "/miles-transfers", "label": "Miles Transfers", "navKey": "MILES_TRANSFERS" },
    { "link": "/airline-classes", "label": "Airline Classes", "navKey": "AIRLINE_CLASSES" },
    { "link": "/promo-campaigns", "label": "Promo Campaigns", "navKey": "PROMO_CAMPAIGNS" },
    { "link": "/users", "label": "Users", "navKey": "USERS" },
    {
      "link": "/sales-organization",
      "label": "Sales Organization",
      "navKey": "SALES_ORGANIZATION",
      "group": "admin"
    },
    {
      "link": "/permission-matrix",
      "label": "Permission Matrix",
      "navKey": "PERMISSION_MATRIX",
      "group": "admin"
    },
    {
      "link": "/checklist-tasks",
      "label": "Checklist Tasks",
      "navKey": "CHECKLIST_TASKS",
      "group": "admin"
    },
    {
      "link": "/checklist-templates",
      "label": "Checklist Templates",
      "navKey": "CHECKLIST_TEMPLATES",
      "group": "admin"
    },
    {
      "link": "/governance-systems",
      "label": "Systems",
      "navKey": "GOVERNANCE_SYSTEMS",
      "group": "admin"
    },
    {
      "link": "/governance-matrix",
      "label": "Access Matrix",
      "navKey": "GOVERNANCE_MATRIX",
      "group": "admin"
    },
    {
      "link": "/governance-audit-log",
      "label": "Governance Audit Log",
      "navKey": "GOVERNANCE_AUDIT_LOG",
      "group": "admin"
    },
    {
      "link": "/identity-contracts",
      "label": "Contracts",
      "navKey": "IDENTITY_CONTRACTS",
      "group": "admin"
    },
    {
      "link": "/identity-eula-versions",
      "label": "EULA Versions",
      "navKey": "IDENTITY_EULA_VERSIONS",
      "group": "admin"
    },
    {
      "link": "/identity-de-anon-gaps",
      "label": "De-anon Gaps",
      "navKey": "IDENTITY_DE_ANON_GAPS",
      "group": "admin"
    },
    {
      "link": "/identity-audit-log",
      "label": "Identity Audit Log",
      "navKey": "IDENTITY_AUDIT_LOG",
      "group": "admin"
    },
    { "link": "/templates", "label": "Templates", "navKey": "TEMPLATES", "group": "admin" },
    {
      "link": "/status-email-routing",
      "label": "Routing Rules",
      "navKey": "TEMPLATES",
      "group": "admin"
    },
    {
      "link": "/slack-channels",
      "label": "Slack Channels",
      "navKey": "TEMPLATES",
      "group": "admin"
    },
    { "link": "/shifts", "label": "Agency Shifts", "group": "admin", "navKey": "USERS" },
    {
      "link": "/agency-parameters",
      "label": "Agency Parameters",
      "group": "admin",
      "navKey": "AGENCY_PARAMETERS"
    }
  ]
}
